export const ToggleTheme = {
  defaultProps: {
    size: 'md',
    colorScheme: 'blue',
  },
};
